import React from 'react'
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux'
import useAuth from '../../../../features/hooks/useAuth'
import { useGetassetReqQuery, useUpdateassetReqstatusMutation, useUpdateassetReqFinalMutation } from '../../../../features/assetrequest/assetReqApiSlice'
import { useGetUsersQuery, useAddUserAssetsMutation, useHandoverOffTranAssetsMutation } from '../../../../features/users/usersApiSlice';
import { useUpdateAssetintransitMutation } from '../../../../features/addassets/addassetfinalApiSlice'
import Select from 'react-select';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { useAddNewassetTransMutation, useGetassetTransQuery, useUpdateassetTransMutation } from '../../../../features/assetTransApiSlice/assetTransApiSlice'
import { useGetofficeTransQuery, useAddNewofficeTransMutation, useUpdateofficeTransMutation } from '../../../../features/assetTransApiSlice/officeTransApiSlice'
import EnhancedTable from './OffAssetHandoverFormTable'
import { useUpdateOffAssetHandoverMutation } from '../../../../features/addassets/addassetfinalApiSlice'
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, RequestClosureWarapperAccepted, RequestClosureWarapperRejected, AddRemarkButton, BackButtonSpan, ReqWrapper, StoreNameCont, ExtReqWrapper } from '../../../../Styles/CommonStyles'


const Container = styled.div``
const Wrapper = styled.div`
display: flex;
flex-direction: column;
`

const TextWrapper = styled.div`
font-size: 20px;
`
const UserNameContainer = styled.div`
padding-right: 30px;
font-size: 20px;
`
const PreDataCont = styled.div`
`
const ButtonContainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`
const TimeAndNameCont = styled.div`
display: flex;
font-size: 20px;
justify-content: space-between;
`
const TimeWrapper = styled.div`
font-size: 20px;
`
const NoteCountCont = styled.div`
font-size: 22px;
font-weight: 600;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const AcceptAssetsButton = styled(CommonButton)``
const RejectAssetsButton = styled(CommonButton)``

const OffAssetHandoverForm = ({ reqid, setChangepage }) => {

  const [remarkButtonClicked, setRemarkButtonClicked] = useState(false)
  const editor = useRef(null);

  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]

  //Single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })

  //call single user data of the user logged in
  let singleUser_data = getSingleuser && getSingleuser[id]

  //Single Request call
  const { getSingleRequest } = useGetassetReqQuery('allassetReqlist', {
    selectFromResult: ({ data }) => ({
      getSingleRequest: data?.entities
    }),
  })

  //call the req doc which is clicked
  let singleReq_data = getSingleRequest && getSingleRequest[reqid]

  // handing over assets details
  let handoverAssetsIdsArray = singleReq_data?.req_data[0].assets_details

  //reqStatus Update Mutation
  const [updateReqStatus, { isLoading: updateaddassetreqStatusloading }] = useUpdateassetReqstatusMutation()

  //update assets in transit
  const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()

  // asset transaction body logic. All the assets which are being transacted
  //all assets_trans call 
  const {
    data: assetTransdata,
    isLoading: TransLoading,

  } = useGetassetTransQuery('translist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let assetTrans = assetTransdata ? Object.values(assetTransdata?.entities) : []
  const [updateAssetTrans, { isLoading: updatetransloading }] = useUpdateassetTransMutation()

  // find req creator ID who is bo of any office
  let reqCreatorId = singleReq_data?.req_creator.id
  let reqCreatorOffice = singleReq_data?.req_creator.office

  let handOverbyObj = { id: reqCreatorId, name: getSingleuser && getSingleuser[reqCreatorId]?.name, office: reqCreatorOffice, designation: getSingleuser && getSingleuser[reqCreatorId]?.designation[reqCreatorOffice], designationSuffix: getSingleuser && getSingleuser[reqCreatorId]?.designationSuffix[reqCreatorOffice], numSuffix: getSingleuser && getSingleuser[reqCreatorId]?.numSuffix[reqCreatorOffice] }

  //so first search for transaction IDs of alraedy existing transactions of assets
  let transactionIdsofoldassets = assetTrans?.filter(elm => handoverAssetsIdsArray?.includes(elm?.asset_id))?.map(elm => { return elm._id })

  let TransData =
  {
    uniqueReqId: singleReq_data?.uniqueReqId,
    sent_from: reqCreatorOffice,
    sent_to: user_current_office,
    handover_by: handOverbyObj,
    received_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
    time_stamp: new Date()
  }

  //old asset transaction body
  let oldTranslist = { IdsArray: transactionIdsofoldassets, trans_data: TransData }

  // transactions in office
  const {
    data: officeTransdata,
    isLoading: officeTransLoading,

  } = useGetofficeTransQuery('officetranslist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let officeTrans = officeTransdata ? Object.values(officeTransdata?.entities) : []
  const [addNewOffhandoverassetTrans, { isLoading: addNewstoretransloading }] = useAddNewofficeTransMutation()
  const [updateOffhandoverAssetTrans, { isLoading: updatestoretransloading }] = useUpdateofficeTransMutation()

  //create transactions for office hanover of a office
  //so first search for transaction ID of already existing office
  let transIdofOfficewithhandover = officeTrans?.filter(elm => (elm.office === user_current_office) && (elm.transact_for === 'offassethandover'))[0]?._id

  let offTransData =
  {
    uniqueReqId: singleReq_data?.uniqueReqId,
    assets: handoverAssetsIdsArray,
    handover_by: handOverbyObj,
    received_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
    time_stamp: new Date()
  }

  // new officehandover in office transaction body
  let newOffhandoverTranslist = { office: reqCreatorOffice, transact_for: "offassethandover", trans_data: [offTransData] }

  // old officehandover in office transaction body
  let oldOffhandoverTranslist = { Trans_Id: transIdofOfficewithhandover, trans_data: offTransData }

  // update assets body ( also alloc_ofc: "", alloc_user:"", in_transit: false  i.e non transit of assets and alloc_assets are being updated by backend)
  const [updateOffhandoverAssets, { isLoading: updateOffHoloading }] = useUpdateOffAssetHandoverMutation()
  let assetsUpdatebody = { assetsIdsArray: handoverAssetsIdsArray, cur_loc: 'store', cur_loc_name: user_current_office }

  //update asset request final update for acceptance and rejection
  const [updateassetReqfinal, { isLoading: updateassetReqFinalloading }] = useUpdateassetReqFinalMutation()


  //#############################// accept handler //############################################################
  //update status body for accept and insert closure time stamp
  let acceptReqObj = {
    curr_status: "accepted",
    close_time_stamp: new Date()
  }

  // update req also to keep time stamp of acceptance for closure
  let updatReqAcceptBody = { id: reqid, finalReqObj: acceptReqObj }

  // accept handler
  const acceptHandler = async () => {

    try {
      // asset transaction logic
      // for assets those whose transactions already exits
      await updateAssetTrans(oldTranslist)
      // transaction of BOs in office
      if (transIdofOfficewithhandover) {
        await updateOffhandoverAssetTrans(oldOffhandoverTranslist)
      } else {
        await addNewOffhandoverassetTrans(newOffhandoverTranslist)
      }
      // update assets being handedover
      await updateOffhandoverAssets(assetsUpdatebody)

      // status of request to be accepted and close time stamp
      await updateassetReqfinal(updatReqAcceptBody)

      //assets in non-Transit are updated in backend

      setChangepage([true, false, false, false])
      return alert('Assets accepted and this request is closed')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  //#############################// reject handler//############################################################
  let rejectReqObj = {
    curr_status: "rejected",
    close_time_stamp: new Date()
  }

  // update req also to keep time stamp of rejection for closure
  let updatReqRejectBody = { id: reqid, finalReqObj: rejectReqObj }

  //reject handler
  let finalnontransitbody = { selectedAssetarray: handoverAssetsIdsArray, transtatus: false }
  const rejectHandler = async () => {
    try {
      await updateassetReqfinal(updatReqRejectBody)
      await updateAssetinTran(finalnontransitbody)
      setChangepage([true, false, false, false])
      return alert('Assets rejected and this request is closed')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }


  return (
    <Container>
      <BackArrowContainer onClick={() => setChangepage([true, false, false, false])}><ArrowLeftIcon /><BackButtonSpan >Back to Category Table</BackButtonSpan></BackArrowContainer>
      {(singleReq_data?.curr_status !== 'rejected') && (singleReq_data?.curr_status !== 'accepted') && <AddRemarkButton onClick={() => setRemarkButtonClicked(true)}>Add Remark</AddRemarkButton>}
      <Wrapper>
        <ReqWrapper>
          <PreDataCont>
            {getSingleRequest[reqid]?.req_data.map((elm, ind) =>
              <PreDataWrap key={ind}>
                <HeadingWrap>
                  <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                </HeadingWrap>
                {elm.assets_details && <div style={{ margin: '15px' }}><span style={{ fontSize: '20px' }}>Requested Asset Details (selected in the checkbox):</span></div>}
                {elm.assets_details && <EnhancedTable intSelectedAssets={elm?.assets_details} />}
                <TextWrapper>
                  Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                </TextWrapper>
                <TimeAndNameCont>
                  <TimeWrapper>
                    {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                  </TimeWrapper>
                  <UserNameContainer>
                    {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                  </UserNameContainer>
                </TimeAndNameCont>
              </PreDataWrap>)}
          </PreDataCont>
        </ReqWrapper>
        {remarkButtonClicked && <ButtonContainer>
          {<AcceptAssetsButton onClick={acceptHandler}> Accept Assets </AcceptAssetsButton>}
          {<RejectAssetsButton onClick={rejectHandler}>Reject Assets</RejectAssetsButton>}
        </ButtonContainer>}

        {/* request Closure logic */}
        {(singleReq_data?.curr_status === 'accepted') && <RequestClosureWarapperAccepted>This Request has been closed. The assets has been accepted by  {`${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data.name?.lastName}-${user_current_office}-${singleUser_data?.designation[user_current_office]} ${singleUser_data?.designationSuffix[user_current_office]}`} </RequestClosureWarapperAccepted>}
        {(singleReq_data?.curr_status === 'rejected') && <RequestClosureWarapperRejected>This Request has been closed. The assets has been rejected by {`${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data.name?.lastName}-${user_current_office}-${singleUser_data?.designation[user_current_office]} ${singleUser_data?.designationSuffix[user_current_office]}`}   </RequestClosureWarapperRejected>}
      </Wrapper>
    </Container>
  )
}

export default OffAssetHandoverForm